import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { RootState, useTypedSelector } from "../store"

const OtpProtectedRoute = ({ children }: { children: ReactNode }) => {
	const auth = useTypedSelector((state: RootState) => state.auth)
	const isOTPRequired: boolean = auth.isOtpRequired
	const isAuthenticate: boolean = auth.isAuthenticate
	const isResetPassword: boolean = auth.user?.userPasswordReset ?? false
	const resetToken: string = auth.user?.resetToken ?? ""

	// is required an otp code to finish the login process
	if (isOTPRequired) {
		return <Navigate to="/otp" />
	} else if (isResetPassword) {
		return <Navigate to={`/change-password?resetToken=${resetToken}`} />
	}

	// is required an otp code to finish the login process
	else if (isAuthenticate) {
		return <Navigate to="/" />
	}

	return children
}

export default OtpProtectedRoute
